var render = function (_h,_vm) {var _c=_vm._c;return _c(require(("@/assets/svgs/" + (_vm.props.name) + ".svg?inline")).default,_vm._g(_vm._b({ref:_vm.data.ref,tag:"Component",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},'Component',_vm.data.attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }